(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vv-wholesale-moq-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const japaneseMinimum = 200000;
    const chineseMinimum = 100000;
    let scheduled = false;

    const parseMoney = (text) => {
      const normalized = text.replace(/[^0-9.,-]/g, '').replace(/,/g, '');
      const value = Number.parseFloat(normalized);
      return Number.isFinite(value) ? Math.round(value * 100) : null;
    };

    const visibleLineTotal = (row) => {
      if (!row) return null;
      const prices = Array.from(row.querySelectorAll('.cart-item__totals .price--end, .cart-item__totals .price'))
        .filter((element) => {
          if (element.closest('s')) return false;
          const style = window.getComputedStyle(element);
          return style.display !== 'none' && style.visibility !== 'hidden';
        });
      return prices.length ? parseMoney(prices.at(-1).textContent || '') : null;
    };

    const formatMoney = (cents, currency) =>
      new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);

    const setMessage = (message, subtotal, minimum, currency) => {
      if (!message) return;
      const unmet = subtotal > 0 && subtotal < minimum;
      message.hidden = !unmet;
      if (!unmet) return;
      const current = message.querySelector('[data-vv-current]');
      const remaining = message.querySelector('[data-vv-remaining]');
      if (current) current.textContent = formatMoney(subtotal, currency);
      if (remaining) remaining.textContent = formatMoney(minimum - subtotal, currency);
    };

    const setButtonState = (button, blocked) => {
      if (!button) return;
      if (blocked) {
        if (!button.disabled) button.dataset.vvMoqDisabled = 'true';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('vv-wholesale-moq__blocked');
      } else if (button.dataset.vvMoqDisabled === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.classList.remove('vv-wholesale-moq__blocked');
        delete button.dataset.vvMoqDisabled;
      }
    };

    const updateGate = (gate) => {
      const drawer = gate.closest('cart-drawer');
      const japaneseLines = [];
      const chineseLines = [];

      gate.querySelectorAll('[data-vv-line]').forEach((line) => {
        const index = line.dataset.index;
        const row = drawer
          ? drawer.querySelector(`#CartDrawer-Item-${index}`)
          : document.querySelector(`#CartItem-${index}`);
        const displayed = visibleLineTotal(row);
        const fallback = Number.parseInt(line.dataset.fallbackCents || '0', 10);
        const cents = displayed === null ? fallback : displayed;
        if (line.dataset.group === 'japanese') japaneseLines.push(cents);
        if (line.dataset.group === 'chinese') chineseLines.push(cents);
      });

      const japaneseSubtotal = japaneseLines.reduce((sum, cents) => sum + cents, 0);
      const chineseSubtotal = chineseLines.reduce((sum, cents) => sum + cents, 0);
      const japaneseUnmet = japaneseSubtotal > 0 && japaneseSubtotal < japaneseMinimum;
      const chineseUnmet = chineseSubtotal > 0 && chineseSubtotal < chineseMinimum;
      const blocked = japaneseUnmet || chineseUnmet;
      const currency = gate.dataset.currency || 'USD';

      setMessage(gate.querySelector('[data-vv-japanese-message]'), japaneseSubtotal, japaneseMinimum, currency);
      setMessage(gate.querySelector('[data-vv-chinese-message]'), chineseSubtotal, chineseMinimum, currency);
      gate.hidden = !blocked;

      const button = drawer
        ? drawer.querySelector('#CartDrawer-Checkout')
        : document.querySelector('#main-cart-footer #checkout');
      setButtonState(button, blocked);

      if (!drawer) {
        document.querySelectorAll('#main-cart-footer .additional-checkout-buttons').forEach((container) => {
          container.hidden = blocked;
        });
      }
    };

    const updateAll = () => {
      scheduled = false;
      document.querySelectorAll('[data-vv-moq-gate]').forEach(updateGate);
    };

    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(updateAll);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
    } else {
      scheduleUpdate();
    }

    new MutationObserver(scheduleUpdate).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
